export enum MenuSistemaEnum {
  CaixaTem_Sondas = 10001,
  CaixaTem_Devolucao = 10002,
  CaixaTem_HistoricoTransacoes = 10003,
  CaixaTem_ExtratoRecarga = 10004,
  CaixaTem_SolicitacaoRecarga = 10005,
  CaixaTem_EmpresaTransporte = 10006,
  CaixaTem_Usuarios = 10007,
  CaixaTem_MinhaEmpresa = 10008,
  C_Bilhetagem_RelatorioPrestacaoContas = 20066,
  Bilhetagem_EntidadesPublicas = 20001,
  Bilhetagem_Usuarios = 20002,
  Bilhetagem_Contas = 20003,
  Bilhetagem_Funcao = 20004,
  Bilhetagem_VeiculosMapa = 20005,
  Bilhetagem_SistemaBilhetagem = 20006,
  Bilhetagem_EmpresaTransporte = 20007,
  Bilhetagem_ComissoesPorEmpresa = 20008,
  Bilhetagem_Veiculos = 20009,
  Bilhetagem_CaixaMagica = 20010,
  Bilhetagem_CodigoTarifario = 20011,
  Bilhetagem_PontoParada = 20012,
  Bilhetagem_Linhas = 20013,
  Bilhetagem_GrupoLinhas = 20014,
  Bilhetagem_Integracao = 20015,
  Bilhetagem_BeneficiosConta = 20016,
  Bilhetagem_Escala = 20017,
  Bilhetagem_Lojas = 20018,
  Bilhetagem_Instituicao = 20019,
  Bilhetagem_ExportacaoContabil = 20020,
  Bilhetagem_SubsidioPublico = 20021,
  Bilhetagem_ConciliacaoPorViagem = 20022,
  Bilhetagem_ConciliacaoPorLote = 20023,
  Bilhetagem_ConciliacaoDeViagens = 20065,
  Bilhetagem_AprovacaoRegistroViagem = 20025,
  Bilhetagem_RelatorioArrecadacaoRodoviario = 20026,
  Bilhetagem_RelatorioContas = 20027,
  Bilhetagem_RelatorioFaixaHoraria = 20028,
  Bilhetagem_RelatorioFaturamentoDiario = 20029,
  Bilhetagem_RelatorioFaturamentoMensal = 20030,
  Bilhetagem_RelatorioBeneficio = 20031,
  Bilhetagem_RelatorioUsoPorLinha = 20032,
  Bilhetagem_RelatorioUtilizacao = 20033,
  Bilhetagem_RelatorioVendasLojas = 20034,
  Bilhetagem_RelatorioVendasPOS = 20035,
  Bilhetagem_RelatorioVendasTiqueteira = 20036,
  Bilhetagem_RelatorioViagem = 20037,
  Bilhetagem_RelatorioFechamentoVeiculo = 20063,
  Bilhetagem_ContasBloqueadas = 20038,
  Bilhetagem_ProgramacaoViagens = 20039,
  Bilhetagem_RubricasContabeis = 20040,
  Bilhetagem_AprovacaoSolicitacaoRecarga = 20041,
  Bilhetagem_BloquearContas = 20042,
  Bilhetagem_TipoPerfil = 20043,
  Bilhetagem_AprovacaoEmpresaGestora = 20044,
  Bilhetagem_DecisaoManualFoto = 20045,
  Bilhetagem_ParametrosSistema = 20046,
  Bilhetagem_CadastroCedente = 20047,
  Bilhetagem_CalendarioOperacional = 20048,
  Bilhetagem_RelatorioHistoricoViagem = 20049,
  Bilhetagem_RecargaCashback = 20050,
  Bilhetagem_RelatorioDashBoard = 20051,
  Bilhetagem_CadastroPraca = 20052,
  Bilhetagem_CadastroTaxasAdquirente = 20053,
  Bilhetagem_TransferenciaCaixaTem = 20054,
  Bilhetagem_UploaddeArquivoBanrisul = 20055,
  Bilhetagem_RelatorioPayGoBanrisul = 20056,
  Bilhetagem_RelatorioBanrisulPayGo = 20057,
  Bilhetagem_RelatorioBatimento = 20058,
  Bilhetagem_RelatorioSinteticoBanrisul = 20059,
  Bilhetagem_RelatorioLiquidacao = 20060,
  Bilhetagem_RelatorioUtilizacaoVeiculo = 20062,
  Bilhetagem_RelatorioSinteticoRecargas = 20064,
  Bilhetagem_RelatorioPrestacaoContas = 20066,
  Bilhetagem_RelatorioQRAvulso = 20067,
  Bilhetagem_CadastroTipoDocumento = 20068,
  Bilhetagem_RelatorioAnaliticoRecargas = 20069,
  Bilhetagem_RelatorioSolicitacaoBeneficio = 20070,
  Bilhetagem_VtRelatorioUtilizacao = 20071,
  Bilhetagem_VtPedidosEmpresas = 20072,
  Bilhetagem_VtPedidosEmpresasDetalhado = 20073,
  Bilhetagem_VtPedidos = 20074,
  Bilhetagem_VtAprovManual = 20075,
  Bilhetagem_VtAprovManualDetalhado = 20076,
  Bilhetagem_TaxaAdministrativa = 20077,
  Bilhetagem_RelatorioQRAvulsoJasper = 20078,
  Bilhetagem_RelatorioSinteticoDeVendasDaLoja = 20079,
  Bilhetagem_RelatorioFaturamentoDiarioSinteticoJasper = 20080,
  Bilhetagem_RelatorioFaturamentoDiarioAnaliticoJasper = 20081,
  Bilhetagem_RelatorioUtilizacaoVeiculoJasper = 20083,
  Bilhetagem_RelatorioFechamentoVeiculoJasper = 20087,
  Loja_CadastroConta = 30001,
  Loja_AtualizarConta = 30002,
  Loja_AberturaCaixa = 30003,
  Loja_Recarga = 30004,
  Loja_ContasBloqueadas = 30005,
  Loja_BloquearContas = 30006,
  Loja_ExtratoUtilizacao = 30007,
  Loja_ExtratoRecarga = 30008,
  Loja_AprovacaoContestacao = 30009,
  Loja_AprovacaoSolicitacaoBeneficios = 30010,
  Loja_SolicitacaoRessarcimento = 30011,
  Loja_Estorno = 30012,
  Loja_RelatorioRecargasEfetuadas = 30018,
  Tiqueteira_EmpresaGestora = 40001,
  Tiqueteira_AdicionarContato = 40002,
  Tiqueteira_NovaSolicitacaoRecarga = 40003,
  Tiqueteira_SolicitacoesRecarga = 40004,
  Tiqueteira_Relatorio = 40005,
  Administrativo_UsuarioRoot = 50001,
  Administrativo_UsuarioAdministrador = 50002,
  AppPrestacaoContas_PrestacaoContas = 60001,
}
